import { css } from '@emotion/core';
import { tokens, applyFont, media, buttonNormalize } from '@domain-group/fe-brary';
var colors = tokens.colors,
  typography = tokens.typography;
export var tabColour = colors.neutral.heavy.default;
export var tabInactiveColour = colors.neutral.heavy.default;
export var tabBorderColour = colors.primary.medium.default;
export var tabCountColour = colors.neutral.heavy.default;
export var container = {
  name: "14zkhj9",
  styles: "padding:10px 15px 200px;"
};
export var tabTitle = /*#__PURE__*/css("margin:16px 0 12px;", applyFont(typography.heading), " color:", colors.neutral.heavy.default, ";", media('>=tablet'), "{margin:24px 0 16px;}");
export var tabContainer = /*#__PURE__*/css("margin-top:24px;", media('>=tablet'), "{position:relative;top:-33px;}");
export var errorMessage = {
  name: "1is0qkf",
  styles: "padding:20px 0;"
};
export var paginationContainer = {
  name: "xi606m",
  styles: "text-align:center;"
};
export var paginationText = {
  name: "1qwecua",
  styles: "display:inline-block;padding:5px;"
};
export var paginationIcon = {
  name: "4cc208",
  styles: "display:inline-flex;position:relative;top:4px;"
};
export var paginationButton = /*#__PURE__*/css(buttonNormalize, ";padding:10px;color:", colors.interactive.base.default, ";cursor:pointer;&:focus{outline:0;}");
export var field = /*#__PURE__*/css("display:block;width:100%;min-width:300px;padding-top:0;padding-bottom:5px;", media('>=tablet'), "{display:inline-block;padding-top:10px;padding-bottom:10px;}");
export var searchBar = /*#__PURE__*/css("display:block;", media('>=tablet'), "{display:inline-block;width:500px;}");
export var searchBarInner = {
  name: "79elbk",
  styles: "position:relative;"
};
export var tabbedPanelContainer = {
  name: "48plj4",
  styles: "margin-left:3px;text-align:left;display:flex;"
};
export var mobileContainer = /*#__PURE__*/css("display:block;margin:0 10px;", media('>=tablet'), "{display:none;}");
export var desktopContainer = /*#__PURE__*/css("display:none;", media('>=tablet'), "{display:block;margin:0 10px;}", media('>=desktop'), "{margin:0;}");
export var listingCountDisclaimer = /*#__PURE__*/css("color:", colors.neutral.medium.default, ";", applyFont(typography.mini), " margin-top:28px;", media('>=tablet'), "{margin-top:40px;}");
export var listingCountDisclaimerIcon = {
  name: "19tx9b7",
  styles: "width:15px;height:15px;display:inline-block;vertical-align:middle;"
};
export var listingCountDisclaimerLabel = {
  name: "x2nffg",
  styles: "display:inline;vertical-align:middle;margin-left:5px;"
};
export var mobileSortButton = /*#__PURE__*/css(buttonNormalize, ";float:right;color:", colors.neutral.heavy.default, ";", applyFont(typography.bodyBold), ";margin-right:10px;");